// get ecustomer list for admin workforce
export const RESET_GET_CUSTOMER_PAYMENT_BY_ID = "RESET_GET_CUSTOMER_PAYMENT_BY_ID";
export const GET_CUSTOMER_PAYMENT_BY_ID = "GET_CUSTOMER_PAYMENT_BY_ID";
export const GET_CUSTOMER_PAYMENT_BY_ID_SUCCESS = "GET_CUSTOMER_PAYMENT_BY_ID_success";
export const GET_CUSTOMER_PAYMENT_BY_ID_FAILURE = "GET_CUSTOMER_PAYMENT_BY_ID_failure";
